<template>
  <div class="aifv-list">
    <div class="aifv-div-top">
      <form action="/" class="logo-container">
        <van-search v-model="searchValue" right-icon="" shape="round" placeholder="搜索内容" @search="onCourseSearchEnter"
          :clearable="true" clear-trigger="always" @clear="clearSearchValue">
          <template #left-icon>
            <van-icon name="search" />
          </template>
        </van-search>
      </form>
    </div>
    <div class="aifv-list-container" v-if="isNone && employeeList.length > 0">
      <van-list v-model="postState.loading" :finished="postState.finished" :finished-text="postState.finishText"
        @load="handleEmployee">
        <div class="item-container" v-for="item in employeeList" :key="item.id" @click="handleItemClick(item)">
          <img :src="item.headPicUrl" v-if="item.headPicUrl" class="item-cover" alt="">
          <img src="@/assets/images/aifv/img14.png" v-else class="item-cover" alt="">
          <div class="item-info">
            <div class="item-title">{{ item.hcpName }}</div>
            <div class="item-txt">{{ item.hospitalName }}</div>
          </div>
          <img src="@/assets/images/aifv/img13.png" class="item-arrow" alt="">
        </div>
      </van-list>
    </div>
    <div class="empty-block" v-else-if="!isNone">
      <img src="../../assets/images/zone/img18.png" class="empty-img" alt="" />
      <div class="empty-txt">暂无内容</div>
    </div>
  </div>
</template>
<script>
import { debounce } from '@/utils/util'
import { getEmployeeHcp } from '@/api/aifv'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  name: 'aifvList',
  data () {
    return {
      searchValue: '',
      employeeList: [],
      postState: {
        pageNo: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        finishText: '没有更多了'
      },
      isNone: true
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    this.handleEmployee()
  },
  methods: {
    handleItemClick(item) {
      this.$router.push({
        path: '/AIFV',
        query: {
          aifvMultiCode: item.multiCode
        }
      })
    },
    clearSearchValue () {
      this.searchValue = ''
      this.postState = {
        pageNo: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        finishText: '没有更多了'
      }
      this.employeeList = []
      this.handleEmployee()
    },
    onCourseSearchEnter: debounce(function() {
      this.postState = {
        pageNo: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        finishText: '没有更多了'
      }
      this.employeeList = []
      this.handleEmployee()
    }, 400),
    handleEmployee () {
      let params = {
        pageNum: this.postState.pageNo,
        pageSize: this.postState.pageSize,
        email: this.userInfo.email, // 'XWang202@ITS.JNJ.com', //
        name: this.searchValue
      }
      getEmployeeHcp(params)
        .then(res => {
          this.$toast.clear()
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.postState.loading = false
              this.postState.finished = true
              this.isNone = false
              return false
            }
            this.postState.finished = false
            this.postState.loading = false
            if (res.data.list.length < this.postState.pageSize) {
              this.postState.finished = true
            }
            if (res.code === 0 && res.data.list) {
              this.employeeList = this.employeeList.concat(res.data.list)
            }
            this.postState.pageNo++
            setTimeout(() => {
              if (this.employeeList.length === 0) {
                this.isNone = false
                this.postState.finishText = ''
              } else if (this.employeeList.length > 0) {
                this.isNone = true
              }
            })
          }
        })
        .catch(err => {
          this.$toast.clear()
          console.log('err:', err)
        })
      // const res = await getEmployeeHcp(this.searchValue)
      // this.employeeList = res.data.data
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.aifv-list {
  width: 100%;
  min-height: 100vh;
  background: #F9F8F7;

  .aifv-div-top {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 60px;
    background: #F9F8F7;
  }

  /deep/ .van-search {
    background: transparent;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 12px 16px;
    box-sizing: border-box;

    .van-search__content {
      background: #fff;

      .van-field__control {
        color: #949BA5;
        font-weight: 400;
        font-size: 13px;
        &::placeholder {
          color: #949BA5;
          font-weight: 400;
          font-size: 13px;
        }
      }
    }
  }

  .aifv-list-container {
    width: 100%;
    min-height: calc(100vh - 62px);
    background: #fff;
    border-radius: 8px 8px 0 0;
    box-shadow: inset 0px -1px 1px 0px rgba(255, 255, 255, 0.25);
    position: relative;
    top: 60px;
    box-sizing: border-box;

    .item-container {
      display: flex;
      align-items: center;
      padding: 16px 26px;
      box-sizing: border-box;

      .item-cover {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        margin-right: 6px;
      }

      .item-info {
        flex: 1;

        .item-title {
          font-size: 14px;
          color: #000000;
          font-family: Source Han Sans CN, Source Han Sans CN;
          line-height: 20px;
          margin-bottom: 4px;
        }

        .item-txt {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-size: 12px;
          line-height: 20px;
          color: #7A8494;
        }
      }

      .item-arrow {
        width: 16px;
        height: 16px;
        display: block;
      }
    }
  }
}

.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 200px;
  padding-bottom: 20px;

  .empty-img {
    width: 185px;
    display: block;
    margin-bottom: 4px;
  }

  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/AIFV/aifvList.vue